var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"label":_vm.label,"value":_vm.formattedValue,"disabled":_vm.disabled,"filled":"","outlined":"","dense":"","background-color":"#fff"},on:{"input":_vm.updateModel}})
}
var staticRenderFns = []

export { render, staticRenderFns }